/** Society flat type normalize — keep in sync with SocietyAppBackend/src/utils/flatTypeNormalize.ts */

export const FLAT_TYPE_MAX_LENGTH = 50;

export function normalizeFlatTypeKey(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const collapsed = String(raw).trim().replace(/\s+/g, ' ');
  if (!collapsed) return null;
  return collapsed.toLowerCase();
}

export function canonicalizeFlatTypeDisplay(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const collapsed = String(raw).trim().replace(/\s+/g, ' ');
  if (!collapsed) return null;
  return collapsed;
}

export function uniqueFlatTypeDisplays(
  displays: Array<string | null | undefined>,
): string[] {
  const byKey = new Map<string, string>();
  for (const d of displays) {
    const key = normalizeFlatTypeKey(d);
    if (!key) continue;
    const display = canonicalizeFlatTypeDisplay(d);
    if (!display) continue;
    if (!byKey.has(key)) byKey.set(key, display);
  }
  return Array.from(byKey.values()).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true }),
  );
}

export function flatMatchesSelectedTypes(
  flatType: string | null | undefined,
  selectedDisplays: string[],
): boolean {
  if (selectedDisplays.length === 0) return true;
  const key = normalizeFlatTypeKey(flatType);
  if (!key) return false;
  const selectedKeys = new Set(
    selectedDisplays.map((d) => normalizeFlatTypeKey(d)).filter(Boolean) as string[],
  );
  return selectedKeys.has(key);
}
